import softAvail from "./review/soft-avail.jst";
import softCommute from "./review/soft-commute.jst";
import softSummary from "./review/soft-summary.jst";
import questions from "./review/questions.jst";
import similar from "./review/similar.jst";

export default {
    SoftReviewAvail: softAvail,
    SoftReviewCommute: softCommute,
    SoftReviewSummary: softSummary,
    Questions: questions,
    Similar: similar,
};
